import React from 'react'

const Paperplane = props => (
  <svg viewBox="0 0 24 23.99" {...props}>
    <path
      d="M24 1a.29.29 0 010-.09 1.11 1.11 0 00-.09-.31V.53A1.3 1.3 0 0023.7.3l-.11-.1-.05-.05-.14-.06h-.12L23 0h-.09a1.13 1.13 0 00-.35.09l-22 11A1 1 0 00.76 13l7.15 1.78-.91 8.1a1 1 0 00.45 1A1 1 0 008 24a.91.91 0 00.51-.14l4.7-2.86 2 2.57A1 1 0 0016 24h.18a1 1 0 00.82-.7l7-22a1.06 1.06 0 000-.3zM3.87 11.68L17.21 5l-8.49 7.89zm5.35 9.42l.5-4.55 2.28 2.9zm6.4-.22l-5.27-6.78 10.54-9.79z"
      fill={props.fill}
    />
  </svg>
)

export default Paperplane
